import { Player, Skyjo, ENV } from "@/skyjo/game";

export class Players extends Array<Player> {

    joinTheGame(pseudo: string): boolean {
        if (!!this.me || !pseudo || this.length === ENV.MAX_PLAYER) return false
        return !!this.push(new Player(this.length, pseudo))
    }

    get isEnoughPlayers(): boolean { return this.length >= ENV.MIN_PLAYER }

    get canJoinThePlayers(): boolean { return (!this.me && this.length < ENV.MAX_PLAYER) }

    get me(): Player | undefined { return this.find((player) => player.me) }

    setMe(pseudo: string | undefined) { this.forEach(player => { player.me = player.pseudo === pseudo }) }

    get other(): Player[] { return this.filter((player) => !player.me) }

    get isMyTurn(): boolean { return this.isPlaying === this.me }

    get isCreator() { return this.find((player) => player.creator) }

    get beginner() { return this.find((player) => player.beginner) }

    setBeginner() {
        this.forEach(player => player.beginner = false);
        if (this.closer)
            this.closer.beginner = true
        else
            [...this].sort((playerA, playerB) => playerB.score - playerA.score)[0].beginner = true
        this.resetCloser()
        this.setPlaying(this.beginner)
    }

    get closer() { return this.find((player) => player.closer) }

    resetCloser() {
        this.forEach(player => player.closer = false)
    }

    setCloser(closer: Player) {
        this.forEach(player => player.closer = player === closer ? true : false)
    }

    get isPlaying(): Player | undefined { return this.find((player) => player.playing) }

    setPlaying(playing: Player) { this.forEach(player => player.playing = player === playing ? true : false) }

    resetPlaying() { this.forEach(player => player.playing = false) }

    get allHasReturnTwoCards(): boolean { return this.filter((player) => player.hasReturnTwoCards === false).length === 0 }

    nextPlayer() {
        const nextPlayerId = (this.isPlaying!.id + 1) % this.length
        const nextPlayer = this.find(player => player.id === nextPlayerId)!
        this.setPlaying(nextPlayer)
    }

    returnAllCards(skyjo: Skyjo) { this.forEach(player => player.returnAllCards(skyjo)); }

    resetScores() {
        this.forEach((player: Player) => player.resetScore())
    }

    calculScores() {
        this.forEach(player => player.calculScore());
        if (this.closer && this.closer.score !== this.minScore) {
            this.closer.scoreTotal.score += this.closer.score
            this.closer.scoreTotal.detail += '*2';
        }

    }

    isWinner(player: Player): boolean { return player.scoreTotal.score === this.minHighScore }

    isLooser(player: Player): boolean { return player.scoreTotal.score === this.maxHighScore }

    get minHighScore(): number { return this.reduce((prv, cur) => Math.min(prv, cur.scoreTotal.score), 1000) }

    get maxHighScore(): number { return this.reduce((prv, cur) => Math.max(prv, cur.scoreTotal.score), -1000) }

    get minScore(): number { return this.reduce((prv, cur) => Math.min(prv, cur.score), 1000) }
}
